import type { ListenOption } from '@/packages/sxm/sports/channelWaterfall';
import { Button } from '@/ui-components/atoms/Button/Button';
import type { DynamicTableRow } from '@/ui-components/molecules/DynamicTable/DynamicTable';

export const EMPTY_CHANNEL = '—';

export function formatChannel(channel: string | number | undefined): string {
    if (!channel) return EMPTY_CHANNEL;
    return `CH ${channel}`;
}

export function listenLabel(name: string, channel: string | number | undefined): string {
    return `Listen to ${name} on channel ${channel}`;
}

export function ChannelLink({
    channel,
    deepLink,
    ariaLabel,
    staticChip,
}: {
    channel: string | number | undefined;
    deepLink: string | undefined;
    ariaLabel: string;
    staticChip?: boolean;
}) {
    if (!channel) return EMPTY_CHANNEL;
    if (!deepLink && !staticChip) return formatChannel(channel);

    return (
        <Button
            type="button"
            variant="secondary"
            fitting="hug-contents"
            size="x-small"
            href={deepLink}
            linkTarget="_blank"
            ariaLabel={ariaLabel}
            isStatic={!deepLink}
        >
            CH {channel}
        </Button>
    );
}

function optionLabel(option: ListenOption, entityName: string): string {
    if (option.label === entityName) return listenLabel(entityName, option.internetChannel);
    return listenLabel(`${entityName} ${option.label} broadcast`, option.internetChannel);
}

export function buildBroadcastRows(options: ListenOption[], entityName: string): DynamicTableRow[] {
    return options.map((option) => ({
        rowLabel: option.label,
        items: [
            formatChannel(option.channel),
            <ChannelLink
                key={option.key}
                channel={option.internetChannel}
                deepLink={option.deepLink}
                ariaLabel={optionLabel(option, entityName)}
            />,
        ],
    }));
}
